import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import { appAPI } from '../../utils/api';
import { getOrganizationUsageCacheKey, longTermCacheStaleTime } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';
import { useOrganizationId } from './useOrganization';

const intl = getIntl('UseOrganizationUsage', {
    usageLoadFailure: 'Failed to load usage',
});

export type UseOrganizationUsageArgs = {};

export type UseOrganizationUsageReturnValue = {
    usage: APITypes.organizationService.GetOrganizationMaxMedicalProfileUsageResponse | null;
    isLoadingUsage: boolean;
};

export default function useOrganizationUsage({}: UseOrganizationUsageArgs = {}): UseOrganizationUsageReturnValue {
    const organizationId = useOrganizationId();
    const organizationUsageQuery = useQuery({
        queryKey: getOrganizationUsageCacheKey(),
        queryFn: async () => {
            return await appAPI.get<APITypes.organizationService.GetOrganizationMaxMedicalProfileUsageResponse>(
                urls.api.organizations.usage.maxMedicalProfiles(organizationId),
            );
        },
        staleTime: longTermCacheStaleTime,
    });
    useQueryErrorNotify(organizationUsageQuery, intl('usageLoadFailure'));

    return {
        usage: organizationUsageQuery.data || null,
        isLoadingUsage: organizationUsageQuery.isLoading,
    };
}
